import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const CampaignsPage = lazy(() => import('./pages/CampaignsPage'));
const CampaignCreatePage = lazy(() => import('./pages/CampaignCreatePage'));
const CampaignDetailPage = lazy(() => import('./pages/CampaignDetailPage'));

export const ROUTES = [
    {
        path: '/campaigns',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CampaignsPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/campaigns/new',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CampaignCreatePage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/campaigns/:id',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CampaignDetailPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/campaigns/:id/edit',
        element: (
            <Suspense fallback={<Spinner block />}>
                <CampaignCreatePage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
